import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import CausedError from "./CausedError.js";
class PluginError extends CausedError {
  constructor(message, options) {
    super(message, {
      cause: options.cause
    });
    _defineProperty(this, "plugin", void 0);
    this.plugin = options.plugin;
  }
}
export default PluginError;